export interface AboutInfo {
  brandName: string;
  tagline: string;
  introduction: string;
  story: string;
  features: { title: string; description: string; icon: string }[];
  testimonials: { name: string; avatar: string; content: string; rating: number }[];
  contact: {
    email: string;
    phone: string;
    address: string;
    wechat: string;
    qq: string;
  };
  stats: { label: string; value: string }[];
}

export const aboutInfo: AboutInfo = {
  brandName: '九妖漫画网',
  tagline: '免费在线看漫画全集，高清无删减资源',
  introduction: '九妖漫画网是国内领先的免费漫画在线阅读平台，致力于为广大漫画爱好者提供高清无删减的漫画资源。我们汇聚了海量热门漫画作品，涵盖热血、恋爱、玄幻、悬疑、搞笑、科幻、都市、古风、冒险、奇幻等多种类型，满足不同读者的阅读需求。',
  story: '九妖漫画网成立于2018年，由一群热爱漫画的年轻人创立。创始团队发现国内漫画爱好者常常面临资源分散、更新缓慢、画质不佳等问题，于是决定打造一个集高质量、快速更新、免费阅读于一体的漫画平台。经过多年的不懈努力，九妖漫画网已经发展成为一个拥有数百万用户的知名漫画阅读平台，每日更新数百部漫画作品，为用户提供极致的阅读体验。',
  features: [
    { title: '海量资源', description: '收录数万部热门漫画，涵盖各种类型，满足您的多元阅读需求。', icon: 'ri-stack-line' },
    { title: '高清画质', description: '所有漫画均为高清扫描版本，确保每一页都清晰锐利，细节尽收眼底。', icon: 'ri-hd-line' },
    { title: '每日更新', description: '与出版社同步更新，第一时间为您带来最新章节，追更不等待。', icon: 'ri-refresh-line' },
    { title: '免费阅读', description: '承诺所有漫画资源永久免费，无需付费订阅，让阅读无负担。', icon: 'ri-gift-line' },
    { title: '多端适配', description: '完美适配电脑、平板、手机等多种设备，随时随地畅享阅读。', icon: 'ri-device-line' },
    { title: '用户至上', description: '不断优化阅读体验，用心倾听每一位用户的反馈和建议。', icon: 'ri-user-heart-line' },
  ],
  testimonials: [
    { name: '小李', avatar: '', content: '九妖漫画网真的是我每天必刷的网站！更新速度超快，画质也很清晰，关键是免费的！已经推荐给身边所有喜欢看漫画的朋友了。', rating: 5 },
    { name: '漫画迷小王', avatar: '', content: '用了很多漫画网站，九妖漫画网的体验是最好的。页面干净整洁，没有乱七八糟的广告，分类也很清楚，找漫画特别方便。', rating: 5 },
    { name: '阿花', avatar: '', content: '作为一个重度漫画爱好者，九妖漫画网满足了我对漫画平台的所有期待。资源丰富、更新及时、界面好看，五星好评！', rating: 5 },
    { name: '追漫少年', avatar: '', content: '从大学开始用九妖漫画网，到现在已经三年了。见证了这个平台越来越好，漫画种类越来越多，真的特别棒！', rating: 5 },
  ],
  contact: {
    email: 'contact@jiuyaomanhua.com',
    phone: '400-888-9999',
    address: '北京市朝阳区建国路88号九妖大厦',
    wechat: 'jiuyaomanhua',
    qq: '1234567890',
  },
  stats: [
    { label: '漫画作品', value: '30,000+' },
    { label: '累计用户', value: '500万+' },
    { label: '每日更新', value: '300+' },
    { label: '用户好评率', value: '98%' },
  ],
};